import React, { useEffect } from 'react';
import { PM_PROVIDERS, PROVIDERS_MAP } from 'common/constants/constants';
import PMEntities from './components/PMEntities/PMEntities';
import { useGetExtraDataPerProvider } from './components/PMEntities/hooks/useGetExtraEntitiesData';
import useProviderEntities from 'common/fetchHooks/pmProvider/useProviderEntities';
import ScopesValidationsModal from 'views/oauth/scopes-validations/ScopesValidationsModal';

const PMConfiguration = ({
  selectedManagementTool,
  toggleSnackBar,
  isOrgSettings,
  boards,
  projects,
  toggleModal,
  getBoards,
  entityName
}) => {
  useEffect(() => {
    /* istanbul ignore next */
    getBoards({ with_references: true });
  }, [entityName]);

  const sensorAuth = selectedManagementTool;
  const pmProvider = sensorAuth?.sensor_id;

  // List of entities from the provider (JIRA: Boards, SHORTCUT: Projects+Teams)
  const {
    data: providerEntities,
    loading,
    error
  } = useProviderEntities(sensorAuth?.sensor_id, entityName);

  const providerEntitiesWithExtras = useGetExtraDataPerProvider({
    entity_name: entityName,
    rawData: providerEntities,
    sensor_authorization_id: sensorAuth.id,
    sensorName: PROVIDERS_MAP[sensorAuth.sensor_name.toLowerCase()].name,
    ...(isOrgSettings && {
      chunkSize: pmProvider === PM_PROVIDERS.AZURE_BOARDS ? 25 : 50
    }),
    cachePolicy: 'cache-first'
  });

  return (
    <div className='mt-8'>
      <ScopesValidationsModal sensor={sensorAuth} />

      <PMEntities
        toggleModal={toggleModal}
        isLoading={loading}
        error={error}
        boards={boards}
        providerEntities={providerEntities}
        providerEntitiesWithExtras={providerEntitiesWithExtras}
        projects={projects}
        sensorAuth={sensorAuth}
        isOrgSettings={isOrgSettings}
        entityName={entityName}
        toggleSnackBar={toggleSnackBar}
      />
    </div>
  );
};

export default PMConfiguration;
